import styled from "styled-components";

export const CardStyles = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.colors.semantic.container.white};
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ $rounded, theme }) => $rounded && theme.radius[12]};
`;
